import {
  API_ENDPOINTS,
  FILESYSTEM_DOWNLOAD_DIR,
} from "src/app/core/api-endpoints";

const baseUrl = "https://dev.api.audiovertical.com/";
const clientId = "iUh6EzhrpHI4f9ll410RCHrcEhPdxV7CkVKKf6ic";
const clientSecret =
  "h0xeBpvwV9Y85CNAbBNkSR0reV8aLF9oLRG4oDk2oB9Mi3D7BicypCca5Rck2D3irXtltRkBMduN6gjVGHAmURMbAPDb6xHlVdDrfTvvlcnDoaEnkL0unxsnfTst1ypz";

export const environment = {
  production: true,
  baseUrl,
  apiBase: "https://dev.api.audiovertical.com/api",
  authBase: "https://dev.api.audiovertical.com/auth",
  mediaBase: "https://dev.api.audiovertical.com",
  wsBase: "wss://dev.api.audiovertical.com",
  clientId,
  clientSecret,
  // Bloco no formato esperado pelos serviços portados do audio_vertical_app
  api: {
    baseUrl,
    endpoints: API_ENDPOINTS,
    entity: {
      login: {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: "password",
      },
      profile: <Record<string, unknown>>{
        id: null,
        user: null,
        payment_method: null,
        deadline: null,
        number_revision: null,
        work: null,
        comfort_zone: null,
        biography: null,
        who_you_worked_with: null,
        equipment: null,
        inspiration: null,
        soundcloud: null,
        youtube: null,
        website: null,
        audio_sample: null,
      },
    },
    filesystem: {
      download: FILESYSTEM_DOWNLOAD_DIR,
    },
  },
};
